import { PButton, PTextarea } from "@porsche-design-system/components-react"
import type { TextareaInputEventDetail } from "@porsche-design-system/components-react"
import { useState } from "react"
import { FormattedMessage } from "react-intl"
import { formMessages } from "src/common/form.messages"
import { ButtonGroup, FormLayout, FormLayoutGroup } from "src/components"

interface NotesFormProps {
	initialValue?: string
	isLoading: boolean
	onCancel: () => void
	onSave: (value: string | undefined) => void
}

export const NotesForm = ({ initialValue, isLoading, onCancel, onSave }: NotesFormProps) => {
	const [value, setValue] = useState(initialValue)

	const handleChange = (event: CustomEvent<TextareaInputEventDetail>) => {
		event.preventDefault()
		event.stopPropagation()
		setValue((event.target as HTMLTextAreaElement).value)
	}

	const handleSave = () => onSave(value)

	return (
		<FormLayoutGroup>
			<FormLayout $width="half">
				<PTextarea name="notes" value={value ?? ""} onInput={handleChange} />
			</FormLayout>

			<ButtonGroup withoutMarginTop>
				<PButton loading={isLoading} onClick={handleSave}>
					<FormattedMessage {...formMessages.save} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={onCancel}>
					<FormattedMessage {...formMessages.cancel} />
				</PButton>
			</ButtonGroup>
		</FormLayoutGroup>
	)
}
